<div style="height: 100%">

 <div class="dwform" style="padding-right: 10px;height: 100%;">

	   <div class="dwform-cell-nopadding right-border"
		   style="padding-left: 10px"> <!--LHS Fields -->
		   
		   <div class="dwform-row-gap"></div>
			<div class="dwform-row">
			<label class="label-field">Case:</label>
			<span class="form-required"></span>
            <label style="font-weight: bold">{{valCaseNumber}}</label>

			</div>

			<div class="dwform-row-gap"></div>
			<div class="dwform-row">
            <label class="label-field">Applicant:</label>
            <span class="form-required"></span>
            <label style="font-weight: bold">{{valCaseName}}</label>
					
			</div>
			<div class="dwform-row-gap"></div>
			<hr>
			<div class="dwform-row-gap-half"></div>
			<div class="dwform-row">
				<label class="label-field">Request Id:</label>
				<span class="form-required"></span>
				{{valRequestId}}

			</div>
			<div class="dwform-row-gap"></div>
			<div class="dwform-row-gap-half"></div>
			<div class="dwform-row">
					<label class="label-field">Request Type:</label>
					<span class="form-required">*</span>
					
                <dw-dropdown
                         id="serviceTypeId1"
                         [disabled]="!isEditing"
                         [selectedItem]="selectedServiceRequestTypeId"
                         (itemSelected)="selectedServiceRequestTypeId = $event; setServiceType();"
                         [dataSource]="serviceRequestTypes"
                         [controlWidth]="'240px'" >
                 </dw-dropdown>
					
			</div>
			<div class="dwform-row-gap"></div>
			<div class="dwform-row-gap-half"></div>

			<div class="dwform-row">
				<label class="label-field">Agency Service:</label><span class="form-required"></span>
				 <dw-dropdown
                         id="serviceDefId1"
                         [disabled]="!isEditing"
                         [selectedItem]="selectedServiceDefId"
                         (itemSelected)="selectedServiceDefId = $event; setServiceDef();"
                         [dataSource]="serviceDefs"
                         [controlWidth]="'240px'" >
                 </dw-dropdown>
				
			</div>

           <!-- Start and End date -->
           <div class="dwform-row-gap"></div>
           <div class="dwform-row-gap-half"></div>

           <label class="label-field">Service Start Date:</label>
           <span class="form-required">*</span>

           <input class="input-field-short" style="width:80px;"
                  [disabled]="!isEditing"
                  id="startDateId"
                  mask="9999-99-99" [dropSpecialCharacters]="false"
                  showMaskTyped="true"
                  [(ngModel)]="startDate"
                  placeholder="<Start date>" type="text"/>
           <div style="display: inline-block; width: 30px;"></div>
           <label class="label-field-half" style="width:30px;">To:</label>
           <span class="form-required">*</span>

           <input class="input-field-short" style="width:80px;"
                  id="endDateId"
                  [disabled]="!isEditing"
                  mask="9999-99-99" [dropSpecialCharacters]="false"
                  showMaskTyped="true"
                  [(ngModel)]="endDate"
                  placeholder="<End date>" type="text"/>

			<div class="dwform-row-gap"></div>
		    <div class="dwform-row-gap-half"></div>

			<div class="dwform-row">
					<label class="label-field">Amount requested:</label>
					<span class="form-required">*</span>
					<input class="input-field-short" id="amount"
						   style="width: 80px;text-transform: capitalize"
						   [(ngModel)]="valAmountRequested" [disabled] = "!isEditing"
						   placeholder="<Amount/Quantity>"
						   type="text">

			<div class="dwform-row-gap"></div>
			<div class="dwform-row-gap"></div>
			<div class="dwform-row">

            <label class="label-field">Unit of Measure:</label>
            <span class="form-required">*</span>
             <dw-dropdown
                        [disabled]="!isEditing"
                        [controlWidth]="'180px'"
                        [dataSource]="uomList"
                        (itemSelected)="unitOfMeasure = $event"
                        [controlWidth]="'180px'"
                        [selectedItem]="unitOfMeasure">
             </dw-dropdown>
					
		</div>
		</div>
	  </div>


	<!----------------------->
	<!-- ERROR LINE --------->
	<!----------------------->
	<div class="error-line" [hidden]='!strErr.length'
		 style="text-align:left;bottom: 50px;">{{strErr}}</div>
	<!----------------------->
	<!-- SAVE STRIP        -->
	<!----------------------->
	<div class="save-close-strip" style="bottom: 13px;">

		<button mat-button class="command-button" [disabled]="!submitEnabled"
				(click)="submitRecord()" matTooltip="Save the record"
				mat-button>
			<mat-icon>check_circle_outline</mat-icon>
			Submit
		</button>
		<button mat-button class="command-button" [disabled]="!cancelEnabled"
				(click)="cancelSubmitRecord()" matTooltip="Cancel edits" mat-button>
			<mat-icon>highlight_off</mat-icon>
			Cancel
		</button>
	</div>
</div>
</div>


